import { useEffect } from "react";
import { motion } from "framer-motion";
import { MaskedLine } from "@/components/Reveal";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
};

export default function PageHero({ eyebrow, titleLines, description, image, alt }) {
  return (
    <section data-testid="page-hero" className="relative bg-oxford overflow-hidden">
      <div className="absolute inset-0">
        {image && (
          <motion.img
            src={image}
            alt={alt || ""}
            className="w-full h-full object-cover"
            initial={{ scale: 1.08, opacity: 0 }}
            animate={{ scale: 1, opacity: 0.35 }}
            transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
          />
        )}
        <div className="absolute inset-0 bg-gradient-to-b from-oxford/70 via-oxford/60 to-oxford" />
      </div>
      <img src="/brand/isotipo-gold.webp" alt="" className="absolute -right-20 top-1/2 -translate-y-1/2 w-[380px] opacity-[0.06] pointer-events-none" />
      <div className="absolute left-0 bottom-16 w-[60%] h-px bg-gradient-to-r from-gold/60 to-transparent -rotate-[8deg] origin-left pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-36 pb-20 lg:pt-48 lg:pb-28">
        <motion.div
          className="flex items-center gap-4"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className="h-px w-10 bg-gold" />
          <span className="eyebrow">{eyebrow}</span>
        </motion.div>
        <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-[1.05]">
          {titleLines.map((line, i) => (
            <MaskedLine key={i} delay={0.35 + i * 0.12} immediate>
              {line}
            </MaskedLine>
          ))}
        </h1>
        {description && (
          <motion.p
            className="mt-7 max-w-2xl text-base lg:text-lg leading-relaxed text-steel"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            {description}
          </motion.p>
        )}
      </div>
    </section>
  );
}
